<div class="about-container" [class.audit-print-route]="isPrintView">
  @if (isPrintView) {
  <app-print-preview-bar
    viewName="Audit Trail"
    [studyName]="studyName"
    [contextLine]="printContextLine"
    [enableColumnSelection]="false"></app-print-preview-bar>
  }
  @if (appState$ | async; as appState) {
  <div class="bpx-detail about-meta">
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Logged In User</span>
      <span class="bpx-detail__value">{{ appState.loggedInUser || 'N/A' }}</span>
    </div>
    <div class="bpx-detail__item">
      <span class="bpx-detail__label">Version</span>
      <span class="bpx-detail__value">{{ appState.appVersion || 'N/A' }}</span>
    </div>
  </div>
  <div class="bpx-toolbar" *ngIf="!isPrintView">
    <button type="button" class="bpx-btn bpx-btn--primary" (click)="downloadTroubleshootingLog()">
      Download Troubleshooting Log
    </button>
    <a (click)="navigateToPrintView()"
      class="bpx-btn printer-view-link"
      [class.toggle-link--disabled]="!canPrintAuditTrail"
      [attr.aria-disabled]="!canPrintAuditTrail"
      [attr.tabindex]="canPrintAuditTrail ? 0 : -1"
      [title]="canPrintAuditTrail ? '' : 'Save the study to print its audit trail'">
      <mat-icon fontIcon="print"></mat-icon>
      <span>Print View</span>
    </a>
  </div>
  }

  <div class="about-table bpx-table">
    <table mat-table [dataSource]="auditTrailDataSource" class="mat-elevation-z0">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>
          User
          <button class="col-filter-btn"
            [class.col-filter-btn--active]="isColumnFilterActive('name')"
            [matMenuTriggerFor]="nameFilterMenu"
            (click)="$event.stopPropagation()">
            <mat-icon>filter_list</mat-icon>
          </button>
          <mat-menu #nameFilterMenu="matMenu">
            <div class="col-filter-content" (click)="$event.stopPropagation()">
              <div class="col-filter-header">
                <mat-checkbox
                  [checked]="areAllSelected('name')"
                  [indeterminate]="isColumnFilterActive('name')"
                  (change)="toggleSelectAll('name')">
                  (Select All)
                </mat-checkbox>
              </div>
              <div class="col-filter-list">
                @for (val of getUniqueColumnValues('name'); track val) {
                  <mat-checkbox
                    [checked]="isColumnValueChecked('name', val)"
                    (change)="toggleColumnValue('name', val)">
                    {{ val }}
                  </mat-checkbox>
                }
              </div>
            </div>
          </mat-menu>
        </th>
        <td mat-cell *matCellDef="let element">{{ element.name }}</td>
      </ng-container>

      <ng-container matColumnDef="userId">
        <th mat-header-cell *matHeaderCellDef>User ID</th>
        <td mat-cell *matCellDef="let element">{{ element.userId }}</td>
      </ng-container>

      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>Date</th>
        <td mat-cell *matCellDef="let element">
          {{ element.date ? (element.date | date:'MM-dd-yyyy HH:mm:ss') : '' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="isSuperUser">
        <th mat-header-cell *matHeaderCellDef>Is Super User</th>
        <td mat-cell *matCellDef="let element">
          <span class="bpx-flag" [class.bpx-flag--on]="element.isSuperUser">{{ element.isSuperUser }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>
          Action
          <button class="col-filter-btn"
            [class.col-filter-btn--active]="isColumnFilterActive('action')"
            [matMenuTriggerFor]="actionFilterMenu"
            (click)="$event.stopPropagation()">
            <mat-icon>filter_list</mat-icon>
          </button>
          <mat-menu #actionFilterMenu="matMenu">
            <div class="col-filter-content" (click)="$event.stopPropagation()">
              <div class="col-filter-header">
                <mat-checkbox
                  [checked]="areAllSelected('action')"
                  [indeterminate]="isColumnFilterActive('action')"
                  (change)="toggleSelectAll('action')">
                  (Select All)
                </mat-checkbox>
              </div>
              <div class="col-filter-list">
                @for (val of getUniqueColumnValues('action'); track val) {
                  <mat-checkbox
                    [checked]="isColumnValueChecked('action', val)"
                    (change)="toggleColumnValue('action', val)">
                    {{ val }}
                  </mat-checkbox>
                }
              </div>
            </div>
          </mat-menu>
        </th>
        <td mat-cell *matCellDef="let element">{{ element.action }}</td>
      </ng-container>

      <ng-container matColumnDef="appVersion">
        <th mat-header-cell *matHeaderCellDef>App Version</th>
        <td mat-cell *matCellDef="let element">{{ element.appVersion }}</td>
      </ng-container>

      <ng-container matColumnDef="comment">
        <th mat-header-cell *matHeaderCellDef>Comments</th>
        <td mat-cell *matCellDef="let element">{{ element.comment }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="auditTrailColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: auditTrailColumns"></tr>
    </table>

    @if (!auditTrailDataSource.filteredData.length) {
    <p class="bpx-empty">No audit trail entries to show.</p>
    }
  </div>

  @if (isPrintView) {
  <div class="audit-print-pages">
    @for (pageRows of auditTrailPrintPages; track pageRows) {
    <section class="audit-print-page">
      <table class="audit-print-table">
        <thead>
          <tr>
            <th>User</th>
            <th>User ID</th>
            <th>Date</th>
            <th>Is Super User</th>
            <th>Action</th>
            <th>App Version</th>
            <th>Comments</th>
          </tr>
        </thead>
        <tbody>
          @for (row of pageRows; track row) {
          <tr>
            <td>{{ row.name }}</td>
            <td>{{ row.userId }}</td>
            <td>{{ row.date ? (row.date | date:'MM-dd-yyyy HH:mm:ss') : '' }}</td>
            <td>{{ row.isSuperUser }}</td>
            <td>{{ row.action }}</td>
            <td>{{ row.appVersion }}</td>
            <td>{{ row.comment }}</td>
          </tr>
          }
        </tbody>
      </table>
    </section>
    }
  </div>
  <div class="audit-print-footer">
    <div>{{ studyName || '-' }}</div>
    <div>{{ panelName || '-' }} : Spec Rev {{ specVersion || '-' }}</div>
    <div>Web App Version: {{ appVersion || '-' }}</div>
  </div>
  }
</div>
